import { maxSizeMackbook, maxSizeMobile } from "@/theme";
import styled from "@emotion/styled";

export const ImageEvent = styled.div`
   width: 100%;
   padding-bottom: 80%;
   background-size: cover;
   background-repeat: no-repeat;
`